import request from '@/utils/request'
import axios from 'axios'
import { getToken, TokenKey } from '@/utils/auth'

// 获取企业微信聊天记录分页列表
export function getGroupForwardDetail(params) {
  return request({
    url: '/health-user-engage/wecom/groupForward/detail',
    method: 'post',
    data: params
  })
}

// 查询医生与患者所在企微群的聊天记录
export function getWeComGroupChatHistory(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/history',
    method: 'post',
    data
  })
}

// 判断当前医患关系的企微白名单、加群及退群状态
export function judgePatientInGroupAndCompleteInfo(data) {
  return request({
    url: '/health-user-engage/wecom/groupGuide/judgePatientInGroupAndCompleteInfo',
    method: 'post',
    data
  })
}

// 查询患者最近一次退群及删除智能医助的明细
export function queryPatientLatestQuitAndAssistantRemovalStatus(data) {
  return request({
    url: '/health-user-engage/wecom/groupGuide/queryPatientLatestQuitAndAssistantRemovalStatus',
    method: 'post',
    data
  })
}

// 获取企业微信个人或群二维码
export function getWeComQrCode(data) {
  return request({
    url: '/health-user-engage/wecom/getWeComQrCode',
    method: 'post',
    data
  })
}

// 记录健管成功推送企微加群二维码埋点
export function reportWeComGroupQrPushed(data) {
  return request({
    url: '/health-user-engage/wecom/groupEngagement/qrPushed',
    method: 'post',
    data
  })
}

// 上线并接管企微群人工服务
export function onlineWeComGroupTakeover(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/takeover/online',
    method: 'post',
    data
  })
}

// 下线并释放企微群人工接管
export function offlineWeComGroupTakeover(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/takeover/offline',
    method: 'post',
    data
  })
}

// 查询当前工单对应企微群的人工接管状态
export function getWeComGroupTakeoverStatus(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/takeover/status',
    method: 'post',
    data
  })
}

// 人工接管期间发送企微群文本消息
export function sendWeComGroupText(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/takeover/sendText',
    method: 'post',
    data
  })
}

// 上传企微消息媒体文件，上传规则与 UploadEdit 保持一致。
export async function uploadWeComMediaFile(file) {
  const formData = new FormData()
  formData.append('files', file)
  formData.append('type', 4)
  const response = await axios({
    url: `${process.env.VUE_APP_BASE_API}/file/upload/batch/default/name`,
    method: 'post',
    data: formData,
    headers: {
      [TokenKey]: getToken(),
      'content-type': 'multipart/form-data'
    }
  })
  const { code, data = [] } = response?.data || {}
  if (Number(code) !== 0 || !data[0]?.path) throw new Error('企微图片上传失败')
  return data[0]
}

// 人工接管期间发送企微群图片或文件消息
export function sendWeComGroupMedia(data) {
  return request({
    url: '/health-user-engage/wecom/groupChat/takeover/sendMedia',
    method: 'post',
    data
  })
}
